import { render, staticRenderFns } from "./ClinicAdd.vue?vue&type=template&id=4faf0a58"
import script from "./ClinicAdd.vue?vue&type=script&lang=js"
export * from "./ClinicAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports